import { useLang } from '@/i18n';
import styles from './index.module.scss';
import EcoSpace from 'eco-design/base/eco-space';
import EcoSectionCommon from 'eco-design/elements/eco-section-common';
import EcoImg from 'eco-design/base/eco-img';
import EcoSpaceSmall from 'eco-design/base/eco-space-small';

export default function Comp() {
    const { t } = useLang('powerBank.N');
    const items = [
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1743848260377/icon40_community.svg',
            number: t('item1_number'),
            desc: t('item1_desc'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1743848260185/icon40_community%20(1).svg',
            number: t('item2_number'),
            desc: t('item2_desc'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1744014104705/Frame%20128720563.svg',
            number: t('item3_number'),
            desc: t('item3_desc'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1744014120169/Frame.svg',
            number: t('item4_number'),
            desc: t('item4_desc'),
        },
    ];
    return (
        <div className={`${styles.comp} eco-content GtmModuleData-section`} data-section-id="Rapid-N">
            <EcoSpace />
            <EcoSectionCommon title={t('N_title')} />
            <EcoSpaceSmall />
            <div className="comp-N-box">
                <ul className="items">
                    {items.map((item, index) => {
                        return (
                            <li className={`item item-${index + 1}`} key={item.number}>
                                <div className={`item-img item-img-${index + 1}`}>
                                    <EcoImg isOpenLazy pc={item.pc}></EcoImg>
                                </div>
                                <p className="item-number">{item.number}</p>
                                <p className="item-desc">{item.desc}</p>
                            </li>
                        );
                    })}
                </ul>
            </div>
            <EcoSpace />
        </div>
    );
}
